import * as React from 'react';
import Box from '@mui/material/Box';
import { GridTable } from '../../Sidebar/SidebarStyles';
import ReportFilterForm from '../ReportFilterForm';
import ReportTable from '../ReportTable';
import { fetchAcordJsonData, generateExportAcordJsonData } from '../../ApiSevices/ReportApis';
import { Alert, Snackbar } from '@mui/material';

interface TableProps {
    displaysidebar: boolean;
}

interface State {
    loading: boolean;
    AJDdata: any[];
    page: number;
    rowsPerPage: number;
    totalCount: number;
    AJDataInput: AJDInput;
    snackbarOpen: boolean;
    snackbarMessage: any;

}
interface AJDInput {
    jobId: any;
    page: number;
    rowsPerPage: number;
}
class AcordJsonData extends React.Component<TableProps, State> {
    constructor(props: TableProps) {
        super(props);
        this.state = {
            loading: false,
            AJDdata: [],
            page: 0,
            rowsPerPage: 100,
            totalCount: 0,
            AJDataInput: {
                jobId: null,
                page: 0,
                rowsPerPage: 100,
            },
            snackbarOpen: false,
            snackbarMessage: '',

        };
    }


    fetchData = async (page: number, rowsPerPage: number, AJDataInput: AJDInput) => {
        this.setState({ loading: true });
        try {
            const res = await fetchAcordJsonData(AJDataInput.jobId, page, rowsPerPage,);
            if (res?.data?.length > 0) {
                this.setState({
                    AJDdata: res?.data || [],
                    totalCount: res.totalCount || 0,
                    page,
                    rowsPerPage
                });
            } else {
                this.setState({ AJDdata: [] });
                this.showSnackbar('No data available for the given JobId', 'error');
            }

        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFilterSubmit = (AJDataInput: AJDInput) => {
        this.setState({ AJDataInput }, () => {
            this.fetchData(0, this.state.rowsPerPage, AJDataInput);
        });
    };

    handleExportExcel = async (AJDInput: AJDInput) => {
        this.setState({ loading: true });
        try {
            const fileBlob = await generateExportAcordJsonData(AJDInput.jobId,);
            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;
            const filename = `AcordJsonData_Report_${new Date().toISOString().replace(/[:.]/g, '')}.xlsx`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Acord Json Data:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (event: unknown, newPage: number) => {
        const { rowsPerPage, AJDataInput } = this.state;
        this.fetchData(newPage, rowsPerPage, AJDataInput);
    };

    handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const { AJDataInput } = this.state;
        this.fetchData(0, newRowsPerPage, AJDataInput);
    };

    showSnackbar = (message: string, severity: 'error') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };


    render() {
        const { loading, AJDdata, totalCount, page, rowsPerPage, snackbarOpen, snackbarMessage } = this.state;
        const { displaysidebar } = this?.props;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <>
                        <Box
                            sx={{
                                padding: '2px 0',
                                backgroundColor: '#f8f8f8',
                                borderBottom: '1px solid #ddd',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    marginLeft: '8px',
                                    textTransform: 'uppercase',
                                }}
                            >
                                ACORD JSON DATA
                            </span>
                        </Box>
                        <ReportFilterForm onSubmit={this.handleFilterSubmit} onExport={this.handleExportExcel} showBroker={false} showStatus={false} showFromDate={false} showToDate={false} showGenerteBtn={false} showExcelBtn={false} showSubmitBtn={true} showJobid={true} />
                        <Box sx={{ overflow: 'hidden', height: '100%', width: '100%' }}>
                            <ReportTable
                                data={AJDdata}
                                totalCount={totalCount}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={this.handlePageChange}
                                onRowsPerPageChange={this.handleRowsPerPageChange}
                            />
                        </Box>
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={1500}
                            onClose={() => this.setState({ snackbarOpen: false })}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <Alert onClose={() => this.setState({ snackbarOpen: false })} severity="error" sx={{ width: "100%" }}>
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
                    </>
                </GridTable>

            </>
        );
    }
}

export default AcordJsonData;